// extracted by mini-css-extract-plugin
export default {"-large":"wBUtRHOh1oBiF2dSDn67","container":"WRAM_fNKhTAdVAjjdQs8","selected":"Nb7_IeZ7TrTbtoZi2cy4","smallerMargin":"qQwTAr_pkI6nxusw0ccC","biggerMargin":"SuDXjrXalLu3qFkNTIRk"};